$(window).load(function() {
	$('.js-flexslider-homepage').flexslider({
		animation: "slide"
	});

	$('.js-flexslider-project-details').flexslider({
		animation: "slide",
		controlNav: "thumbnails"
	});
});

/*
 * svg4everybody.js
 * I had to add this manually instead of Bower b/c of a pull request
 * that fixes IE10+ from an infinite loop.
 * https://github.com/jonathantneal/svg4everybody/pull/86
 */
!function(root, factory) {
    "function" == typeof define && define.amd ? define([], function() {
        return root.svg4everybody = factory();
    }) : "object" == typeof exports ? module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.0.0 | github.com/jonathantneal/svg4everybody */
    function embed(svg, g) {
        if (g) {
            var viewBox = !svg.getAttribute("viewBox") && g.getAttribute("viewBox"), fragment = document.createDocumentFragment(), clone = g.cloneNode(!0);
            for (viewBox && svg.setAttribute("viewBox", viewBox); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            svg.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        xhr.onreadystatechange = function() {
            if (4 === xhr.readyState) {
                var x = document.createElement("x");
                x.innerHTML = xhr.responseText, xhr.s.splice(0).map(function(array) {
                    embed(array[0], x.querySelector("#" + array[1].replace(/(\W)/g, "\\$1")));
                });
            }
        }, xhr.onreadystatechange();
    }
    function svg4everybody(opts) {
        function oninterval() {
            for (var use, svg, i = 0; i < uses.length; ) {
                if (use = uses[i], svg = use.parentNode, svg && /svg/i.test(svg.nodeName)) {
                    var src = use.getAttribute("xlink:href");
                    if (polyfill && (!validate || validate(src, svg, use))) {
                        var url = src.split("#"), url_root = url[0], url_hash = url[1];
                        if (svg.removeChild(use), url_root.length) {
                            var xhr = svgCache[url_root] = svgCache[url_root] || new XMLHttpRequest();
                            xhr.s || (xhr.s = [], xhr.open("GET", url_root), xhr.send()), xhr.s.push([ svg, url_hash ]),
                            loadreadystatechange(xhr);
                        } else {
                            embed(svg, document.getElementById(url_hash));
                        }
                    }
                } else {
                    i += 1;
                }
            }
            requestAnimationFrame(oninterval, 17);
        }
        opts = opts || {};
        var uses = document.getElementsByTagName("use"), polyfill = "polyfill" in opts ? opts.polyfill : /\bEdge\/12\b|\bTrident\/[567]\b|\bVersion\/7.0 Safari\b/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 537, validate = opts.validate, requestAnimationFrame = window.requestAnimationFrame || setTimeout, svgCache = {};
        polyfill && oninterval();
    }
    return svg4everybody;
});
svg4everybody();


/*
 * Masonry Grid
 * To get Masonry to work with this setup, I had to override
 * bower.json with full package file. Then exclude outlayer
 * and other scripts in manifest.json under dependencies.
 */
(function () {
    var grid = document.querySelector('.js-cards');
    var msnry = new Masonry( grid, {
      itemSelector: '.js-card',
      columnWidth: 200
    });
})();


/*
 * Header search bar close button
 */
(function () {
    $('.search__label--header').on('click', function() {
        $(this).toggleClass("js-search-close");
    });
})();


/*
 * Pure JS version of above, still buggy
 */
// function header_search_close() {
//  var header_search = document.querySelectorAll(".search__label--header");
//  header_search.onclick = function(event) {
//      if(!this.hasClass("js-search-close")) {
//          this.classList.remove("js-search-close");
//      } else {
//          this.classList.add("js-search-close");
//      }
//  };
// }
// header_search_close();


/*
 * Prevent empty anchors with hashes from their
 * default behaviors if in desktop mode > 1023px
 */
(function () {
    if( window.innerWidth > 1023 ) {
        var anchors = document.getElementsByTagName('a');
        for (var i = 0; i < anchors.length; i++) {
            anchors[i].addEventListener('click', function (e) {
                var lastChar = this.href.substr(this.href.length - 1);
                if (lastChar === "#") {
                    e.preventDefault();
                }
            }, false);
        }
    }
})();
